import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { today } from '../../dates';
import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// "Recording for": the day the answers belong to, as a native date input that
// stops at today. Changing it opens the same step for the chosen day, whose
// own saved answers then show; nothing is carried over from the day before.
export function RecordDate({ date, step }) {
  const { text } = useLanguage();
  const navigate = useNavigate();

  const onChange = useCallback(function({ currentTarget }) {
    if (currentTarget.value !== '' && currentTarget.value <= today()) {
      navigate(`/diary/record/${ currentTarget.value }/${ step }`);
    }
  }, [ step, navigate ]);

  return (
    <label className={ styles.field }>
      <span className={ styles.label }>{ text.recordingFor }</span>

      <input className={ styles.input } type='date' value={ date } max={ today() } onChange={ onChange }/>
    </label>
  );
}
